import { render, staticRenderFns } from "./PopUpDefault.vue?vue&type=template&id=ac80bd0a&scoped=true"
import script from "./PopUpDefault.vue?vue&type=script&lang=js"
export * from "./PopUpDefault.vue?vue&type=script&lang=js"
import style0 from "./PopUpDefault.vue?vue&type=style&index=0&id=ac80bd0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac80bd0a",
  null
  
)

export default component.exports